import { useContext } from 'react';
import { IsMobileContext } from './IsMobileContext';

export function useIsMobile(breakpoint: 768 | 1024 = 768): boolean {
  const ctx = useContext(IsMobileContext);
  if (!ctx) {
    throw new Error('useIsMobile must be used within IsMobileProvider');
  }
  if (breakpoint === 1024) return ctx.isNarrow;
  return ctx.isMobile;
}
